/*
 * Os campos de um modelo "sem texto livre", no lugar da área de texto do
 * composer: um por {{campo}} do texto, com rótulo, dica e ajuda. A caixa
 * leva a classe `Composer-flexible`: o core dá a ela a altura que daria à
 * área de texto, e ela rola por dentro.
 *
 * Trocar de modelo (ou voltar ao texto livre, quando a tag permite) é pelo
 * menu ⊕ da barra do editor (ver index.tsx): nada a mais no corpo do composer.
 */
import Component from 'flarum/common/Component';
import classList from 'flarum/common/utils/classList';
import { t } from '../../utils/settings';
/** Um id de elemento a partir da chave do campo (acentos e espaços viram traço). */
const fieldId = (key, index) => `CanelaTemplateField-${index}-${key.replace(/[^\p{L}\p{N}]+/gu, '-')}`;
export default class TemplatePanel extends Component {
  view() {
    const {
      template
    } = this.attrs;
    return m("div", {
      className: "CanelaTemplatePanel Composer-flexible"
    }, m("p", {
      className: "CanelaTemplatePanel-hint"
    }, t('templates.form_hint', {
      name: template.name
    })), template.fields.map((field, index) => this.field(field, index)));
  }
  field(field, index) {
    const {
      state,
      disabled
    } = this.attrs;
    const id = fieldId(field.key, index);
    const value = state.values[field.key] ?? '';
    const invalid = state.invalid.has(field.key);
    const update = event => this.attrs.oninput(field.key, event.target.value);
    const common = {
      id,
      className: 'FormControl',
      value,
      disabled,
      'aria-required': field.required ? 'true' : undefined,
      'aria-invalid': invalid ? 'true' : undefined,
      'aria-describedby': field.description ? `${id}-help` : undefined
    };
    let control;
    if (field.type === 'select') {
      control = m("select", Object.assign({}, common, {
        onchange: update
      }), m("option", {
        value: ""
      }, field.placeholder || t('templates.select_placeholder')), field.options.map(option => m("option", {
        value: option
      }, option)));
    } else if (field.type === 'textarea') {
      control = m("textarea", Object.assign({}, common, {
        rows: 4,
        placeholder: field.placeholder || undefined,
        oninput: update
      }));
    } else {
      control = m("input", Object.assign({
        type: "text"
      }, common, {
        placeholder: field.placeholder || undefined,
        oninput: update
      }));
    }
    return m("div", {
      key: field.key,
      className: classList('CanelaTemplateField', {
        'is-required': field.required,
        'is-invalid': invalid
      }),
      "data-key": field.key
    }, m("label", {
      className: "CanelaTemplateField-label",
      for: id
    }, field.label, field.required && m("span", {
      className: "CanelaTemplateField-required",
      "aria-hidden": "true"
    }, "*")), control, field.description && m("p", {
      className: "CanelaTemplateField-help helpText",
      id: `${id}-help`
    }, field.description));
  }
}
flarum.reg.add('ramon-canela', 'forum/features/templates/TemplatePanel', TemplatePanel);